// extracted by mini-css-extract-plugin
export default {"noApplicantsContainer":"application_noApplicantsContainer__CpX6X","noApplicants":"application_noApplicants__ibyui","cardContainer":"application_cardContainer__Tfgr1"};